import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { citylogo, cityName, citylogoMobile, applicationLogo, CITY } from 'app/common/const';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild('selectorMobile') selectorMobile: ElementRef;
  @ViewChild('parentSelector') parentSelector: ElementRef;

  citylogo = citylogo;
  citylogoMobile = citylogoMobile;
  cityName = cityName;
  cityMetadata = [];

  applicationLogo = applicationLogo;
  constructor(@Inject(CITY) cityMetadata) {
    this.cityMetadata = cityMetadata.filter((c) => !c.hidden);
  }

  ngOnInit() {
    // console.log('NAME', this.cityName)
  }

  openMobileMenu() {
    this.selectorMobile.nativeElement.classList.toggle('opened');
    this.parentSelector.nativeElement.classList.toggle('opened');
  }

}



// WEBPACK FOOTER //
// ./src/app/common/header/header.component.ts